module.exports = __webpack_public_path__ + "img/_51.0bade08a.png";